import { ContractualFrameworkApi } from "@/api";

export async function getAll() {
  const { data } = await ContractualFrameworkApi.getAll();
  return data;
}
